import { PartnerGroupRules, UserGroupRules } from 'src/graphql';

export enum SiteTabs {
  SiteDocumentation = 'site_documentation',
  Conversations = 'conversations',
  Clients = 'clients',
  MembershipInformation = 'membership_information',
  Projects = 'projects',
  Activity = 'activity',
}

export type SiteTab = {
  label: string;
  value: SiteTabs;
  icon: string;
  allowedRules?: (UserGroupRules | PartnerGroupRules)[];
};

export const SITE_TABS: SiteTab[] = [
  {
    value: SiteTabs.Clients,
    label: 'Clients',
    icon: 'people_alt',
  },
  {
    value: SiteTabs.SiteDocumentation,
    label: 'Documentation',
    icon: 'description',
  },
  {
    value: SiteTabs.Conversations,
    label: 'Conversations',
    icon: 'forum',
  },
  {
    value: SiteTabs.MembershipInformation,
    label: 'Membership Information',
    icon: 'monetization_on',
  },
  {
    value: SiteTabs.Projects,
    label: 'Projects',
    icon: 'perm_media',
  },
  {
    value: SiteTabs.Activity,
    label: 'Activity',
    icon: 'schedule',
    allowedRules: [UserGroupRules.AccessToActivityFeedInSites],
  },
];
